let selectedSlot = null;
let selectedEvent = null;
let timeslotParentCon = null;
let selectedTimeSlotForDate = null;
let bookingDateInput = null;
let bookingDateTimeslotInput = null;
let selectedTimeSlotForDateError = null;
let appointmentTypeId = null;

document.addEventListener("DOMContentLoaded", () => {
  const mtgtwbookingData = JSON.parse(
    document.getElementById("mtgtwbookingData").textContent,
  );
  appointmentTypeId = mtgtwbookingData.appointmentTypeId;
});

// Loading skeleton before data loaded
function renderCalendarSkeleton(count = 3) {
  const calendarList = document.querySelector("#calendar-list");

  calendarList.innerHTML = "";

  for (let i = 0; i < count; i++) {
    calendarList.insertAdjacentHTML(
      "beforeend",
      `<div id="calendar-skeleton" class="mtgtw:border! mtgtw:border-gray-200! mtgtw:rounded-lg! mtgtw:p-4!">
            <div class="mtgtw:flex! mtgtw:items-center! mtgtw:justify-center!"><div class="skeleton mtgtw:h-6! mtgtw:w-40! mtgtw:rounded! mtgtw:mb-4!"></div></div>

            <div class="mtgtw:grid! mtgtw:grid-cols-7! mtgtw:gap-2!">
              ${Array.from({ length: 35 })
                .map(
                  () =>
                    `<div class="skeleton mtgtw:aspect-square! mtgtw:rounded-md!"></div>`,
                )
                .join("")}
            </div>
          </div>`,
    );
  }
}
// Loads timeslots each booking date
function renderTimeSlots(slots) {
  const timeSlotContainer = document.querySelector("#timeslot-container");
  bookingDateTimeslotInput = document.querySelector(
    "#bookingDateTimeslotInput",
  );

  timeSlotContainer.innerHTML = "";

  if (!slots.length) {
    timeSlotContainer.innerHTML = `
            <div class="mtgtw:text-gray-500! mtgtw:text-sm!">
              No available time slots.
            </div>
          `;
    return;
  }

  slots.forEach((slot) => {
    const button = document.createElement("button");

    button.type = "button";
    button.textContent = slot;

    button.className =
      "mtgtw:px-4! mtgtw:py-4! mtgtw:text-xl! mtgtw:font-semibold! mtgtw:bg-transparent! mtgtw:text-primary! mtgtw:border-1! mtgtw:border-primary/50! mtgtw:rounded-md! mtgtw:transition-ease-in-out! mtgtw:duration-200! mtgtw:text-left! mtgtw:cursor-pointer!";

    button.addEventListener("click", () => {
      timeSlotContainer.querySelectorAll("button").forEach((btn) => {
        btn.classList.remove("mtgtw:bg-transparent!", "mtgtw:text-white!");

        const selectedTimeSlotForDate = document.querySelector(
          "#selectedTimeSlotForDate",
        );
        const goToCheckoutBtn = document.querySelector("#goToCheckoutBtn");

        bookingDateTimeslotInput.value = slot;
        selectedSlot = slot;

        selectedTimeSlotForDate.textContent = slot;
        selectedTimeSlotForDate.classList.remove("mtgtw:text-red-600!");
        selectedTimeSlotForDate.classList.add("mtgtw:text-[#00af52]!");
        goToCheckoutBtn.classList.remove("mtgtw:hidden!");
        goToCheckoutBtn.classList.add("mtgtw:flex!");
      });
      TimeSlotValidator();

      button.classList.add("mtgtw:bg-[#00af52]!", "mtgtw:text-white!");
    });

    timeSlotContainer.appendChild(button);
  });
}
// This loads calendar from endpoint
async function loadBookingCalendar() {
  selectedTimeSlotForDate = document.querySelector("#selectedTimeSlotForDate");
  selectedTimeSlotForDateError = document.querySelector(
    ".selectedTimeSlotForDateError",
  );
  timeslotParentCon = document.querySelector("#timeslot-parent-con");
  bookingDateInput = document.querySelector("#bookingDateInput");
  bookingDateTimeslotInput = document.querySelector(
    "#bookingDateTimeslotInput",
  );

  TimeSlotValidator();

  const availabilityUrlEnd =
    `https://app.learnpac.co.uk/wp-json/shopify/v1/appointment-types/${appointmentTypeId}/availability`;
  renderCalendarSkeleton();
  console.log("availabilityUrlEnd:", availabilityUrlEnd);

  const response = await fetch(availabilityUrlEnd);
  const availability = await response.json();
  const blockedDate = "Thu, 17 Sep 2026";

  const filteredAvailability = (Array.isArray(availability) ? availability : []).filter((item) => {
    const availableSeats = Number(item.available_seats ?? item.availableSeats ?? 0);
    const hasTimeSlots = Array.isArray(item.timeSlots) && item.timeSlots.length > 0;

    return item.date !== blockedDate && availableSeats > 0 && hasTimeSlots;
  });

  const events = filteredAvailability.map((item) => {
    const d = new Date(item.date);

    return {
      start: [
        d.getFullYear(),
        String(d.getMonth() + 1).padStart(2, "0"),
        String(d.getDate()).padStart(2, "0"),
      ].join("-"),
      originalDate: item.date,
      slots: item.timeSlots,
      allDay: true,
      display: "background",
    };
  });

  const calendarListEl = document.querySelector("#calendar-list");

  calendarListEl.innerHTML = "";

  const eventMonths = new Set();
  events.forEach((event) => {
    const firstMonth = new Date(event.start);
    const lastDay = new Date(event.end || event.start);
    if (event.end && event.allDay) lastDay.setDate(lastDay.getDate() - 1);

    for (
      const month = new Date(
        firstMonth.getFullYear(),
        firstMonth.getMonth(),
        1,
      );
      month <= lastDay;
      month.setMonth(month.getMonth() + 1)
    ) {
      eventMonths.add(
        `${month.getFullYear()}-${String(month.getMonth() + 1).padStart(2, "0")}-01`,
      );
    }
  });

  const DatesBelowBadgeAlert = document.querySelector("#DatesBelowBadgeAlert");
  switch (true) {
    case eventMonths.size > 1:
      DatesBelowBadgeAlert.classList.add("mtgtw:flex!");
      DatesBelowBadgeAlert.classList.remove("mtgtw:hidden!");

      setTimeout(() => {
        DatesBelowBadgeAlert.classList.remove("mtgtw:opacity-100!");
        DatesBelowBadgeAlert.classList.add("mtgtw:opacity-0!");
      }, 5000);

      setTimeout(() => {
        DatesBelowBadgeAlert.classList.remove("mtgtw:flex!");
        DatesBelowBadgeAlert.classList.add("mtgtw:hidden!");
      }, 6000);
      break;
    default:
      return;
  }

  [...eventMonths].sort().forEach((monthStart) => {
    const monthEl = document.createElement("div");
    monthEl.className = "calendar-month";
    calendarListEl.appendChild(monthEl);

    new FullCalendar.Calendar(monthEl, {
      initialView: "dayGridMonth",
      initialDate: monthStart,
      headerToolbar: {
        center: "title",
      },
      fixedWeekCount: false,
      showNonCurrentDates: false,
      events,
      dayCellDidMount(info) {
        const date = [
          info.date.getFullYear(),
          String(info.date.getMonth() + 1).padStart(2, "0"),
          String(info.date.getDate()).padStart(2, "0"),
        ].join("-");

        const hasEvent = events.some((event) => {
          const eventStartDate = event.start.slice(0, 10);
          const eventEndDate = event.end?.slice(0, 10);

          if (!eventEndDate) return date === eventStartDate;
          if (event.allDay)
            return date >= eventStartDate && date < eventEndDate;
          return date >= eventStartDate && date <= eventEndDate;
        });

        const isToday = new Date().toISOString().slice(0, 10);

        switch (true) {
          case hasEvent:
            info.el.classList.add("hasDate");
            break;
          case isToday === date:
            info.el.classList.add("is-today");
            break;
          default:
            info.el.classList.add("is-disabled-date");
        }
      },

      dateClick(info) {
        if (
          info.dayEl.classList.contains("is-disabled-date") ||
          info.dayEl.classList.contains("is-today")
        )
          return;

        selectedEvent = events.find((e) => e.start === info.dateStr) || null;

        bookingDateInput.value = events.find(
          (e) => e.start === info.dateStr,
        )?.originalDate;

        if (selectedEvent != "") {
          timeslotParentCon.removeEventListener("click", () => {});
          selectedTimeSlotForDate.textContent = "";
          selectedTimeSlotForDateError.classList.add("mtgtw:hidden!");
        }

        const slots = selectedEvent?.slots || [];
        const timeslotContainer = document.querySelector("#timeslot-container");

        document
          .querySelector("#calendar-list-container")
          .classList.remove("mtgtw:basis-full!");
        document
          .querySelector("#calendar-list-container")
          .classList.add("mtgtw:basis-0!");
        setTimeout(() => {
          document
            .querySelector("#calendar-list-container")
            .classList.add("mtgtw:hidden!");
        }, 300);
        document
          .querySelector("#selected-booking-date")
          .classList.remove("mtgtw:hidden!");
        document.querySelector("#selected-booking-date").textContent =
          events.find((e) => e.start === info.dateStr)?.originalDate;

        const reselectBookingDateBtn = document.querySelector(
          "#reselectBookingDateBtn",
        );
        reselectBookingDateBtn.addEventListener("click", () => {
          TimeSlotValidator();

          selectedEvent = null;
          selectedSlot = null;
          bookingDateInput.value = null;
          bookingDateTimeslotInput.value = null;

          document.querySelector("#selected-booking-date").textContent = "";
          selectedTimeSlotForDateError.classList.add("mtgtw:hidden!");

          document
            .querySelector("#calendar-list-container")
            .classList.remove("mtgtw:hidden!");

          const goToCheckoutBtn = document.querySelector("#goToCheckoutBtn");
          goToCheckoutBtn.classList.remove("mtgtw:flex!");
          goToCheckoutBtn.classList.add("mtgtw:hidden!");

          selectedTimeSlotForDate.textContent = "";

          setTimeout(() => {
            document
              .querySelector("#calendar-list-container")
              .classList.remove("mtgtw:basis-0!");
            document
              .querySelector("#calendar-list-container")
              .classList.add("mtgtw:basis-full!");
          }, 5);

          timeslotContainer.classList.remove("mtgtw:flex!");
          timeslotContainer.classList.add("mtgtw:hidden!");
        });

        timeslotContainer.classList.remove("mtgtw:hidden!");
        timeslotContainer.classList.add("mtgtw:flex!");

        renderTimeSlots(slots);
      },
    }).render();
  });
}
// Validate if user selected timeslot
function TimeSlotValidator() {
  timeslotParentCon.addEventListener("click", () => {
    if (selectedEvent) return;

    if (selectedSlot == null) {
      selectedTimeSlotForDateError.classList.remove("mtgtw:hidden!");
    }
  });
}
// Function Open Date Modal
function openBookDateModal() {
  const openBookDateModalOverlay = document.querySelectorAll(
    ".openBookDateModalOverlay",
  );
  const openBookDateModal = document.querySelectorAll(".openBookDateModal");
  const mcFormsWrapper = document.querySelectorAll(".mcforms-wrapper");
  const body = document.body;
  body.classList.add("mtgtw:overflow-hidden!");
  openBookDateModalOverlay.forEach((overlay) => {
    overlay.classList.remove("mtgtw:hidden!");
    overlay.classList.add("mtgtw:block!");
  });
  openBookDateModal.forEach((modal) => {
    modal.classList.remove("mtgtw:hidden!");
    modal.classList.add("mtgtw:block!");
  });
  mcFormsWrapper.forEach((wrapper) => {
    wrapper.classList.add("mtgtw:hidden!");
  });

  console.log("mcFormsWrapper:", mcFormsWrapper);
  loadBookingCalendar();
}
// Function Close Date Modal
function closeBookDateModal() {
  const body = document.body;
  body.classList.remove("mtgtw:overflow-hidden!");
  const openBookDateModal = document.querySelectorAll(".openBookDateModal");
  const openBookDateModalOverlay = document.querySelectorAll(
    ".openBookDateModalOverlay",
  );
  openBookDateModal.forEach((modal) => {
    modal.classList.remove("mtgtw:block!");
    modal.classList.add("mtgtw:hidden!");
  });
  openBookDateModalOverlay.forEach((overlay) => {
    overlay.classList.remove("mtgtw:block!");
    overlay.classList.add("mtgtw:hidden!");
  });
  const mcFormsWrapper = document.querySelectorAll(".mcforms-wrapper");
  mcFormsWrapper.forEach((wrapper) => {
    wrapper.classList.remove("mtgtw:hidden!");
  });
}
